import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Img from 'react-image';
import ClearButton from '../Button/ClearButton';
import ColorMask from '../ColorMask';
import Link from '../../global/NavLink';
import H1Title from '../typography/H1Title';
import HeaderCallout from '../typography/HeaderCallout';
import P from '../typography/P';

const Button = styled(ClearButton)`
  width: 100%;
  margin: 20px 0 0 0;
`;

const CategoryHeader = styled(HeaderCallout)`
  margin: 0;
`;

const Header = styled(H1Title)`
  margin: 3px 0 0 0;
`;

const Image = styled(Img)`
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const ImageWrapper = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  margin: 0 0 15px 0;
`;

const PWithSpace = styled(P)`
  flex: 1 0 auto;
  margin-top: 11px;
`;

const TimeSubHeader = styled(HeaderCallout)`
  margin: 0;
`;

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  max-width: 521px;

  & > a {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

const NewsFeature = ({
  buttonText,
  categoryHeader,
  description,
  heading,
  id,
  image,
  timeSubHeader
}) => (
  <Wrapper>
    <Link to={`/news-article/${id}`}>
      <ImageWrapper>
        <ColorMask />
        <Image
          src={[image && image.src, 'https://placehold.it/227x227']}
          alt={(image && image.alt) || heading}
        />
      </ImageWrapper>
      {categoryHeader && <CategoryHeader>{categoryHeader}</CategoryHeader>}
      <Header>{heading}</Header>
      {timeSubHeader && <TimeSubHeader>{timeSubHeader}</TimeSubHeader>}
      <PWithSpace>{description}</PWithSpace>
      <Button>{buttonText}</Button>
    </Link>
  </Wrapper>
);

NewsFeature.propTypes = {
  buttonText: PropTypes.string,
  categoryHeader: PropTypes.string,
  description: PropTypes.string,
  heading: PropTypes.string,
  image: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.string
  }),
  id: PropTypes.string,
  timeSubHeader: PropTypes.string
};

export default NewsFeature;
